module.exports = __webpack_public_path__ + "media/images/ui__textArrowUp--dark-21d1c82b89d26a4906542fd309fed357.png";